module.exports = __webpack_public_path__ + "img/perkawinan.0f80cc73.png";